import NextArrow from '@/SVG/NextArrow'
import Button from '@/components/Button'
import { useChapter } from '@/context/ChapterContext'
import { useNavigation } from '@/context/NavigationContext'

export default function NextChapter() {
  const { isChangingChapter, currentChapterNumber: currentChapter, nextChapter, totalChapters } = useChapter()
  const { navigateToCredits } = useNavigation()

  const handleNextChapter = () => {
    if (currentChapter === totalChapters) {
      // If we're on the last chapter, show credits
      console.log('Showing credits from NextChapter button', 'navigation')
      navigateToCredits()
    } else {
      // Otherwise go to the next chapter
      console.log('Navigating to next chapter', 'navigation')
      nextChapter()
    }
  }

  return (
    <Button small onClick={handleNextChapter} disabled={isChangingChapter || currentChapter > totalChapters}>
      <NextArrow />
    </Button>
  )
}

export { NextChapter }
